import { useProject } from '@/contexts/ProjectContext';
import { lockedWriteBackMessage } from '@/lib/projectVersionState';
import type { ProjectVersionState } from '@/types/project';

export interface WriteBackLock {
  isLocked: boolean;
  state: ProjectVersionState | (string & {}) | null;
  message: string | null;
}

export function useWriteBackLock(): WriteBackLock {
  const { detail } = useProject();
  const isLocked = Boolean(detail?.is_locked);
  const state = detail?.state ?? null;
  return {
    isLocked,
    state,
    message: isLocked ? lockedWriteBackMessage(state) : null,
  };
}
